// Google Analytics 4 Configuration
import ReactGA from 'react-ga4';

// GA4 Measurement ID - Use import.meta.env for Vite environment variables
export const GA4_MEASUREMENT_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID || 'G-RCMJFZ33NE';

// Initialize GA4
export const initGA4 = () => {
  if (GA4_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    ReactGA.initialize(GA4_MEASUREMENT_ID, {
      gtagOptions: {
        page_title: document.title,
        page_location: window.location.href,
      }
    });
    console.log('✅ GA4 initialized with ID:', GA4_MEASUREMENT_ID);
  } else {
    console.warn('⚠️ GA4 not initialized - Measurement ID not configured');
  }
};

// Track page views
export const trackPageView = (page_path: string, page_title?: string) => {
  ReactGA.send({ 
    hitType: 'pageview', 
    page: page_path,
    title: page_title || document.title
  });
  console.log('📊 GA4 Page View:', page_path);
};

// Track custom events
export const trackEvent = (event_name: string, parameters?: Record<string, any>) => {
  ReactGA.event(event_name, {
    ...parameters,
    event_category: 'user_interaction',
    timestamp: new Date().toISOString(),
  });
  console.log('📊 GA4 Event:', event_name, parameters);
};

// Quiz-specific tracking events
export const trackQuizEvent = (action: string, step?: number, questionId?: number) => {
  trackEvent('quiz_interaction', {
    action,
    step,
    question_id: questionId,
    quiz_type: 'ai_readiness_assessment',
  });
};

// Report-specific tracking events
export const trackReportEvent = (action: string, reportId?: string, persona?: string) => {
  trackEvent('report_interaction', {
    action,
    report_id: reportId,
    persona,
    report_type: 'ai_readiness_persona',
  });
};

// User journey tracking
export const trackUserJourney = (step: string, data?: Record<string, any>) => {
  trackEvent('user_journey', {
    step,
    journey_type: 'ai_readiness_assessment',
    ...data,
  });
};

// Error tracking
export const trackError = (error_type: string, error_message: string, context?: Record<string, any>) => {
  trackEvent('error_occurred', {
    error_type,
    error_message,
    context,
    severity: 'error',
  });
};

// Performance tracking
export const trackPerformance = (metric_name: string, value: number, unit?: string) => {
  trackEvent('performance_metric', {
    metric_name,
    metric_value: value,
    metric_unit: unit || 'ms',
  });
};

// ReactGA4 is now used instead of direct gtag calls
// No need for global window declarations
